import { Stripe, StripeElements } from '@stripe/stripe-js';
import { useMutation } from '@tanstack/react-query';
import { FormEvent } from 'react';

import { userService } from '@src/api/services';
import { CURRENT_DOMAIN, NAVIGATION, SEARCH_KEYS } from '@src/constants';
import {
  onDismissPayFailAlert,
  onShowPayFailAlert,
} from '@src/helpers/payment.helpers';
import { IPlanID } from '@src/interfaces/plans.interfaces';

interface IUseStripeConfirmPayment {
  stripe: Stripe | null;
  elements: StripeElements | null;
  planID?: IPlanID;
}

export const useStripeConfirmPayment = ({
  stripe,
  elements,
  planID,
}: IUseStripeConfirmPayment) => {
  return useMutation({
    mutationFn: async (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      onDismissPayFailAlert();

      if (!stripe || !elements || planID === undefined) {
        onShowPayFailAlert();
        return;
      }

      const geoResponse = await userService.getGeoData();
      const geoData = geoResponse.data.data;

      const response = await userService.getTemporaryToken();
      const newSuccessParams = new URLSearchParams({
        [SEARCH_KEYS.TOKEN]: response.data.data?.token || '',
        [SEARCH_KEYS.PLAN_ID]: planID.toString(),
      });

      const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${CURRENT_DOMAIN}${NAVIGATION.CREATE_PASSWORD}?${newSuccessParams}`,
          payment_method_data: {
            billing_details: {
              address: {
                country: geoData.country_code,
                postal_code: geoData.postal,
              },
            },
          },
        },
      });

      if (error?.message) {
        throw Error(error?.message);
      }
    },
  });
};
